import group from './group'
import initApp  from './initApp';
import initEnv  from './initEnv';
import updateSubdomain from './updateSubdomain';

import {
    setSessionSettings,
    getSessionSettings,
} from './sessionSettings';


const actions = {
    initEnv,
    initApp,
    updateSubdomain,
    setSessionSettings,
    getSessionSettings,
    ...group,
};

export default actions;
